import { gql } from "@apollo/client";

export const FETCH_SALES_LIST = gql`
  query fetchSalesList(
    $providerId: ID!
    $page: Int!
    $pageSize: Int!
    $type: String!
    $search: String
  ) {
    fetchSalesList(
      providerId: $providerId
      page: $page
      pageSize: $pageSize
      type: $type
      search: $search
    ) {
      totalCount
      salesList {
        id
        name
        date
      }
    }
  }
`;

export const FETCH_ORDER_DETAILS = gql`
  query fetchOrderDetails($transactionId: String, $providerId: String) {
    fetchOrderDetails(transactionId: $transactionId, providerId: $providerId) {
      userInfo {
        id
        userName
        contactNumber
        email
      }
      orderInfo {
        orderId
        orderDate
        scheduleDate
        serviceDuration
        serviceMethod
      }
      type
      transferInfo {
        status
        transferAmount
        releaseDate
        transferredAt
        lastError
      }
      paymentSummary {
        itemInfo {
          _id
          title
          price
          uri
          quantity
          checkReview
          variantCombination
          fulfillmentOption {
            type
            address
          }
        }
        fulfillmentType
        wheelDiscount{
          amount
          discount
        }
        coupon {
          code
          discountPercentage
          discountedAmount
          finalAmount
          type
          stripeId
        }
        itemPrice
        subscriptionPoints
        shippingCost
        platformFees
        platformFeesRate
        taxAmount
        taxRate
        stripeTransactionFees
        transactionFees
        totalAmount
        netIncome
        bookedSpots
      }
      deliveryAddress {
        streetName
        cityName
        stateAndZipCode
        country
      }
      inviteesInfo {
        bookedSpots
        invitees
      }
      fullName
      status
      orderStatusList {
        value
        label
      }
    }
  }
`;

export const UPDATE_ORDER_STATUS = gql`
  mutation updateOrderStatus($updateOrderStatusInput: UpdateOrderStatusInput!) {
    updateOrderStatus(updateOrderStatusInput: $updateOrderStatusInput) {
      success
      message
      order {
        _id
        status
        orderStatusHistory {
          status
          updatedAt
          updatedBy
        }
      }
       report {
        orderId
        reportSummary {
          description
          medias {
            key
            uri
            uri_thumbnail
            width
            height
            mediaType
          }
        }
        userInfo {
          userName
          email
          phone
        }
        reportDetails {
          status
          reportedOn
          replyBy
          orderId
          purchaseDate
        }
      }
    }
  }
`;
